export default __webpack_public_path__ + "static/media/avatar.48cd6770.png";